export default __webpack_public_path__ + "static/media/confetti.4ea37647.png";